// Envelope / row -> CSV utilities.
const esc = (v) => {
   if (v === null || v === undefined) return "";
   const s = String(v);
   return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

// New: export using already-filtered rows + visible column objects (in order).
// This is the preferred export path from ReportRunner.
export function rowsToCsv(rows, columns) {
   const header = columns.map((c) => esc(c.label)).join(",");
   const lines = [header];
   for (const row of rows) {
      lines.push(columns.map((c) => esc(row[c.key])).join(","));
   }
   return lines.join("\n");
}

// Legacy: kept for any callers that still pass the full envelope + definition.
export function envelopeToCsv(envelope, definition) {
   const cols = definition.columns;
   const rows = (envelope.groups || []).flatMap((g) => g.rows || []);
   return rowsToCsv(rows, cols);
}

export function downloadCsv(filename, csv) {
   const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
   const url = URL.createObjectURL(blob);
   const a = document.createElement("a");
   a.href = url; a.download = filename;
   document.body.appendChild(a); a.click(); a.remove();
   URL.revokeObjectURL(url);
}
